import styled from 'styled-components';

export const OrgCell = styled.div`
  padding: 6px;
  background-color: var(--color-surface-muted);
  color: var(--color-text);
  border: 1px solid var(--color-border);
  font-weight: 500;
  font-size: 12px;
  line-height: 90%;
  border-radius: 5px;
  align-items: center;
  margin: 20px 0;
`;
